<template>
  <div class="map-reset" @click="$emit('click')" />
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component()
export default class ResetMap extends Vue {

}
</script>

<style>
.map-reset {
  background: url('/assets/images/Maps/Salesmap/others/marker_reset.png');
  background-repeat: 'no-repeat';
  background-position: 'center';
  width: 30px;
  height: 30px;
  position: absolute;
  top: 15px;
  left: 15px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/googleMap/buttons/ResetMap.vue